"use strict";
/*jshint esversion: 6 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
// Plugin Name:		MINDGALLERY
// Plugin URI:		https://mindfolio.webmajstr.cz/mindgallery
// Description:		Smooth Gallery carefully crafted for Mindfolio WP Theme
// Author:			Jakub Runda
// Author URI:		http://webmajstr.cz
// Version:			1.9.5
var mg_server_1 = __importDefault(require("./js/inc/mg_server"));
var MindGalleryServer = new mg_server_1["default"]();
MindGalleryServer.serve();
